import { ButtonHTMLAttributes } from 'react';
import tw from 'twin.macro';

const StyledButton = tw.button`relative flex min-h-[26px] min-w-[25px] bg-neutral-background rounded border border-solid border-gray-1 items-center justify-center overflow-hidden`;
const HoverOpacityWrapper = tw.div`hover:opacity-75`;

export const FilterControllerButton = ({
  children,
  ...props
}: { children: React.ReactNode } & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <HoverOpacityWrapper>
      <StyledButton {...props}>{children}</StyledButton>
    </HoverOpacityWrapper>
  );
};
